export default __webpack_public_path__ + "static/media/sleep.884ca6a8.png";